import { AudienceGraphql, GetAudienceDataQuery, AudienceDataFragmentDoc, GetAudienceDataDocument } from "../../../../generated/apollo-hooks";
import { useStore } from 'react-redux';
import IStore from '../../../infrastructure/store.interface';
import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

export const useLoadAudienceDataQuery = () => {
    const store = useStore<IStore>();
    const apolloClient = useApolloClient();

    return useCallback(
        async (audienceId: any) => {
            const cacheAudience = apolloClient.readFragment<AudienceGraphql>({
                id: `AudienceGraphql:${audienceId}`,
                fragment: AudienceDataFragmentDoc
            });

            if (cacheAudience?.data) {
                return cacheAudience.data;
            }

            const { data } = await apolloClient.query<GetAudienceDataQuery>({
                fetchPolicy: 'network-only',
                query: GetAudienceDataDocument,
                variables: {
                    systemId: store.getState().common.currentSystem,
                    audienceId
                }
            });

            return data?.getAudience?.data;
        },
        [store, apolloClient]
    );
};
